/**
 * Root component of `apps/web` — Phase 5.
 *
 * Integrates TanStack Router as the navigation layer within the
 * data providers (Query + PowerSync).
 *
 * i18n: language-change reactivity is provided by `useI18n().t()`, which
 * internally calls `locale()` to subscribe to the signal. Every
 * component using `t()` updates automatically without needing to
 * remount the RouterProvider. The old `LocaleKeyedRouter` (createMemo
 * keyed on locale()) was removed because it caused a full unmount of the
 * router tree on every language change (including the initial onMount when
 * loading the real catalog), causing visible flicker across the ENTIRE page.
 */

import { type Component, Suspense } from "solid-js";
import { RouterProvider } from "@tanstack/solid-router";

import { AppProviders } from "@/providers/app-providers";
import { router } from "@/router";

export const App: Component = () => (
  <AppProviders>
    <Suspense fallback={null}>
      <RouterProvider router={router} />
    </Suspense>
  </AppProviders>
);
